export const avatar = {
  root: ({ props, parent }: Record<string, any>) => ({
    class: [
      // Font
      'font-normal',
      {
        'max-xl:text-sm': props.size == null || props.size === 'normal',
        'xl:text-[20px]': props.size == null || props.size === 'normal',
        'text-2xl': props.size === 'large',
        'text-3xl': props.size === 'xlarge',
      },
      // Alignments
      'inline-flex items-center justify-center',
      'shrink-0',
      'relative',
      // Sizes
      {
        'max-xl:h-9 max-xl:w-9': props.size === null || props.size === 'normal',
        'xl:h-11 xl:w-11': props.size == null || props.size === 'normal',
        'w-16 h-16': props.size === 'large',
        'w-20 h-20': props.size === 'xlarge',
      },
      { '-ml-4': parent.instance.$style?.name === 'avatargroup' },
      // Shapes
      {
        'max-xl:rounded-md': props.shape === 'square',
        'xl:rounded-xl': props.shape === 'square',
        'rounded-full': props.shape === 'circle',
      },
      { 'border-2': parent.instance.$style?.name === 'avatargroup' },
      // Colors
      'bg-avatar dark:bg-surface-700 text-avatar-text',
      {
        'border-white dark:border-surface-800': parent.instance.$style?.name === 'avatargroup',
      },
    ],
  }),
  image: ({ props }: Record<string, any>) => ({
    class: [
      'h-full w-full',
      {
        'rounded-lg': props.shape === 'square',
        'rounded-full': props.shape === 'circle',
      },
    ],
  }),
};
